import React from "react"
import styled from "~ui/styled"
import pcWatermark from "~assets/images/pc-watermark.png"

const Wrap = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  pointer-events: none;
  user-select: none;
`

/** 更深灰底板，衬托镂空气泡水印 */
const Plate = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

const LogoImage = styled.img`
  width: 72px;
  height: auto;
  display: block;
  object-fit: contain;
`

export default function PcDetailWatermark() {
  return (
    <Wrap aria-hidden>
      <Plate>
        <LogoImage src={pcWatermark} alt="" />
      </Plate>
    </Wrap>
  )
}
